import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';
import { Redirect, Link } from 'react-router-dom';

import * as api from '../../api/api';

class CustomContentFileAssignmentPage extends React.Component {
    constructor(props) {
        super(props);

        let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");

        this.state = {
            fileName: null,
            assignment: [],
            returnUrl: returnUrl,
            needRedirect: false
        };

        this.props.updateLoader({
            loaded: false,
            message: ""
        });

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
    }

    componentDidMount() {

        if (!api.isUserAdmin()) {
            this.setState({
                returnUrl: "/users/permission-denied",
                needRedirect: true
            });

            return;
        }

        api.makeRequest(api.getDisplaysDictionary()).then(
            (getDisplaysResponse) => {

                api.makeRequest(api.getCustomContentFileAssignment(this.props.match.params.id)).then(
                    (getAssignmentResponse) => {

                        api.makeRequest(api.getCustomContentFileDetails(this.props.match.params.id)).then(
                            (getFileDetailsResponse) => {

                                this.setState({
                                    fileName: getFileDetailsResponse.data.data.name,
                                    assignment: getDisplaysResponse.data.data.map((item) => {
                                        return {
                                            displayId: item.id,
                                            checkpoint: item.checkpoint,
                                            checked: getAssignmentResponse.data.data.find((nowAssignment) => nowAssignment === item.id) ? true : false
                                        }
                                        // displayName: item.name,
                                    })
                                });

                                this.props.updateLoader({
                                    loaded: true,
                                    message: ""
                                });
                            },
                            (error) => {
                                this.props.updateLoader({
                                    loaded: true,
                                    message: "Ошибка при получении данных: " + error
                                });

                            }
                        );
                    },
                    (error) => {
                        this.props.updateLoader({
                            loaded: true,
                            message: "Ошибка при получении данных: " + error
                        });
                    }
                );
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при получении данных: " + error
                });
            }
        );
    }

    handleChange(id) {
        this.setState({
            assignment: this.state.assignment.map(item => {
                if (item.displayId == id) {
                    item.checked = !item.checked;
                }

                return item;
            })
        });
    }

    save() {

        this.props.updateLoader({
            loaded: false
        });

        api.makeRequest(api.editCustomContentFileAssignment(this.props.match.params.id, {
            data: {
                devices: this.state.assignment.filter((item => item.checked == true)).map(item => { return item.displayId })
            }
        })).then(
            (response) => {

                this.props.updateLoader({
                    loaded: true
                });

                this.setState({
                    needRedirect: true
                });
            },
            (error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            }
        )
            .catch((error) => {
                this.props.updateLoader({
                    loaded: true,
                    message: "Ошибка при сохранении: " + error
                });
            });
    }

    render() {

        if (this.state.needRedirect) {
            return <Redirect to={this.state.returnUrl} />
        }

        return (
            <div>

                <h4 className="mb-4">Редактирование привязки файла {this.state.fileName}</h4>
                {
                    this.state.assignment.map(item => {
                        return (
                            < div className="m-3" >
                                <input class="form-check-input" type="checkbox"
                                    value={item.displayId}
                                    checked={item.checked}
                                    onChange={() => this.handleChange(item.displayId)}
                                />
                                <label class="ml-2 form-check-label">
                                    {`${item.displayId} [${item.checkpoint.name} - ${item.checkpoint.description}]`}
                                </label>
                            </div>)
                    })
                }

                <div className="mt-3">
                    <button className="btn btn-primary-custom" onClick={this.save}>
                        Сохранить
                    </button>
                    <button className="btn btn-secondary ml-2 btn-with-link">
                        <Link to={this.state.returnUrl}>Назад</Link>
                    </button>
                </div>
            </div >
        );
    }
}

export default CustomContentFileAssignmentPage;


// import React from 'react';
// import "bootstrap/dist/css/bootstrap.css";
// import '../../assets/css/style.css';
// import { Redirect, Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import * as api from '../../api/api';

// class CustomContentFileAssignmentPage extends React.Component {
//     constructor(props) {
//         super(props);

//         let returnUrl = new URLSearchParams(this.props.location.search).get("return_url");

//         this.state = {
//             fileName: null,
//             assignments: [],
//             returnUrl: returnUrl,
//             needRedirect: false
//         };

//         this.props.updateLoader({
//             loaded: false,
//             message: ""
//         });

//         this.handleChangeSelection = this.handleChangeSelection.bind(this);
//         this.save = this.save.bind(this);
//     }

//     componentDidMount() {

//         if (!api.isUserAdmin()) {
//             this.setState({
//                 returnUrl: "/users/permission-denied",
//                 needRedirect: true
//             });

//             return;
//         }

//         // получим устройства
//         api.makeRequest(api.getDisplaysDictionary()).then(
//             (getDisplaysResponse) => {

//                 // получим группы
//                 api.makeRequest(api.getDeviceGroups()).then(
//                     getGroupsResponse => {

//                         // получим привязку
//                         api.makeRequest(api.getCustomContentFileAssignment(this.props.match.params.id)).then(
//                             (getAssignmentResponse) => {

//                                 let assignments = getGroupsResponse.data.data.map((group, i) => {

//                                     return {
//                                         groupName: group.name,
//                                         devices: group.devices.map(deviceId => {
//                                             return {
//                                                 id: deviceId,
//                                                 checked: getAssignmentResponse.data.data.assignment.find(nowAssignment => nowAssignment.displayId == deviceId) ? true : false
//                                             }
//                                         })
//                                     }
//                                 });

//                                 this.setState({
//                                     fileName: getAssignmentResponse.data.data.file.name,
//                                     assignments: assignments
//                                 });

//                                 this.props.updateLoader({
//                                     loaded: true,
//                                     message: ""
//                                 });
//                             },
//                             (error) => {
//                                 this.props.updateLoader({
//                                     loaded: true,
//                                     message: "Ошибка при получении данных: " + error
//                                 });
//                             }
//                         );
//                     },
//                     error => {
//                         this.props.updateLoader({
//                             loaded: true,
//                             message: "Ошибка при получении данных: " + error
//                         });
//                     })
//             },
//             (error) => {
//                 this.props.updateLoader({
//                     loaded: true,
//                     message: "Ошибка при получении данных: " + error
//                 });
//             }
//         );
//     }

//     handleChangeSelection(groupIndex, deviceId, action) {

//         // если меняем привязку к отдельному устройству - меняем флажки у данного устройства из других групп
//         if (deviceId) {
//             this.setState({
//                 assignments: this.state.assignments.map(group => {
//                     return {
//                         groupName: group.groupName,
//                         devices: group.devices.map(device => {
//                             return {
//                                 id: device.id,
//                                 checked: (device.id == deviceId) ? !device.checked : device.checked
//                             }
//                         })
//                     }
//                 })
//             });
//         }
//         else {
//             let assignments = this.state.assignments.slice();

//             assignments[groupIndex].devices = assignments[groupIndex].devices.map(item => {
//                 item.checked = action == "select";
//                 return item;
//             })

//             this.setState({
//                 assignments: assignments
//             });
//         }
//     }

//     save() {

//         this.props.updateLoader({
//             loaded: false
//         });

//         let displayIdList = [];

//         this.state.assignments.forEach(assignmentGroup => {
//             assignmentGroup.devices.forEach(device => {
//                 if (device.checked && !displayIdList.find(id => id == device.id)) {
//                     displayIdList.push(device.id);
//                 }
//             });
//         });

//         api.makeRequest(api.editCustomContentFileAssignment({
//             file: {
//                 id: this.props.match.params.id,
//                 name: this.state.fileName
//             },
//             assignments: displayIdList
//         })).then(
//             () => {

//                 this.props.updateLoader({
//                     loaded: true
//                 });

//                 this.setState({
//                     needRedirect: true
//                 });
//             },
//             error => {
//                 this.props.updateLoader({
//                     loaded: true,
//                     message: "Ошибка при сохранении: " + error
//                 });
//             }
//         )
//             .catch((error) => {
//                 this.props.updateLoader({
//                     loaded: true,
//                     message: "Ошибка при сохранении: " + error
//                 });
//             });
//     }

//     render() {

//         if (this.state.needRedirect) {
//             return <Redirect to={this.state.returnUrl} />
//         }

//         return (
//             <div>

//                 <h4 className="mb-4">Редактирование привязки файла {this.state.fileName}</h4>
//                 {
//                     this.state.assignments.map((assignment, groupIndex) => {

//                         return (
//                             <div className="card card-collapse mt-3">
//                                 <div className="card-header">

//                                     <div className="d-flex">
//                                         <h5 className="mr-auto">
//                                             <a className="collapse-link" data-toggle="collapse" href={"#group_" + groupIndex}>
//                                                 {assignment.groupName}
//                                             </a>
//                                         </h5>

//                                         <a className="pl-2 pr-2" href="#" title="Выбрать все"
//                                             onClick={() => this.handleChangeSelection(groupIndex, null, "select")}>
//                                             <FontAwesomeIcon icon="check" size="sm" color="#333" />
//                                         </a>

//                                         <a className="pl-2 pr-2" href="#" title="Отменить выбор"
//                                             onClick={() => this.handleChangeSelection(groupIndex, null, "unselect")}>
//                                             <FontAwesomeIcon icon="times" size="sm" color="#333" />
//                                         </a>

//                                     </div>

//                                 </div>

//                                 <div className="collapse show" id={"group_" + groupIndex}>
//                                     <div className={assignment.devices.length > 10 ? "card-body scroll " : "card-body"}>
//                                         {
//                                             assignment.devices.map(device => {
//                                                 return (
//                                                     <div className="m-3" >
//                                                         <input type="checkbox"
//                                                             value={device.id}
//                                                             checked={device.checked}
//                                                             onChange={() => this.handleChangeSelection(groupIndex, device.id)}
//                                                         />
//                                                         <label class="ml-2 form-check-label">
//                                                             {device.id}
//                                                         </label>
//                                                     </div>
//                                                 )
//                                             })
//                                         }
//                                     </div>
//                                 </div>
//                             </div>)
//                     })
//                 }

//                 <div className="mt-3">
//                     <button className="btn btn-primary-custom" onClick={this.save}>
//                         Сохранить
//                     </button>
//                     <button className="btn btn-secondary ml-2 btn-with-link">
//                         <Link to={this.state.returnUrl}>Назад</Link>
//                     </button>
//                 </div>
//             </div >
//         );
//     }
// }

// export default CustomContentFileAssignmentPage;